export const intro = {
    title: 'Contact',
};

export const infoMaps = {
    street: 'Stadionweg 57c',
    address: '3077 AS, Rotterdam',
    email: 'info@developers.nl',
};
